// 菜单配置
import { LaptopOutlined, UserOutlined, HomeOutlined, SettingOutlined } from "@ant-design/icons";
// let rootRoute = [];
export const deviceHome = [
  {
    key: "deviceHome",
    label: "设备首页",
  },
];
export const routes = [
  {
    key: "commandIssued",
    label: "已发命令列表",
  },
  {
    key: "history",
    label: "历史记录",
  },
  {
    key: "pressureMeasurement",
    label: "压测记录",
  },
  {
    key: "paixiang",
    label: "派享x86",
  },
];

// const role = localStorage.getItem("role");
// if (role === "root") {
//   rootRoute = [...deviceHome, ...routes];
// } else {
//   rootRoute = [...deviceHome];
// }

// export const SiderMenu = [
//   // {
//   //   key: "system",
//   //   icon: <SettingOutlined />,
//   //   label: `系统管理`,
//   //   children: [
//   //     {
//   //       key: "authorization",
//   //       label: "权限设置",
//   //     },
//   //     {
//   //       key: "role",
//   //       label: "角色管理",
//   //     },
//   //   ],
//   // },
//   {
//     key: "device",
//     icon: <LaptopOutlined />,
//     label: `设备管理`,
//     children: [...rootRoute],
//   },
// ];

export const HeadMenu = [
  // {
  //   label: "主页",
  //   key: "home",
  //   icon: <HomeOutlined />,
  // },

  {
    label: "个人中心",
    key: "personalCenter",
    icon: <UserOutlined />,
    children: [
      {
        key: "myInfo",
        label: "个人信息",
      },
      // {
      //   key: "changeWpd",
      //   label: "修改密码",
      // },
      {
        key: "exit",
        label: "退出",
      },
    ],
  },
];
